import { Component, EventEmitter, Input, OnChanges, OnInit, Output, } from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormArray } from "@angular/forms";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "src/app/services/constants";

@Component({
  selector: "app-step-five",
  templateUrl: "./step-five.component.html",
  styleUrls: ["./step-five.component.css"],
})
export class StepFiveComponent implements OnInit {
  isStepper;
  @Input() filledData: any;
  @Input() isAdd: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  objectProp: any;
  // listing
  allEligibles:any=[];
  allPersonalities:any=[];
  allTravelRequirements:any=[];
  allHire:any=[];
  // form
  form: FormGroup;
  showError: boolean = false;
  constructor( private formBuilder: FormBuilder, private api: AdminService, private toastrService: ToastrService){
    this.form = this.formBuilder.group({  
      id: [""],
      jobEligibleForId: ["", Validators.compose([Validators.required])],
      vaccinationCerificate: [""],
      quicklyNeedForHireId: [""],
      travelRequirementId: [""],
      noOfPeopleRequired: [""],
      personalitiesIds: [""],
      countryCode: [""],
      phoneNumber: [""],
      emailsIds: formBuilder.array([]),
      steps: [""],
    })
   }
   // add new address
newEmail() : FormGroup {
  return this.formBuilder.group({
    emailId : ["", Validators.compose([Validators.pattern(CONSTANT.EMAIL_REGEX)])],
  })
}

getEmail() {
  return (this.form.get('emailsIds') as FormArray).controls; 
}
checkPattern(i){
  let items = this.form.get("emailsIds") as FormArray;
  const seperator = CONSTANT.EMAIL_REGEX;
  const maskSeperator = new RegExp(seperator, 'g');
  let result = maskSeperator.test(items.value[i].emailId); 
  return !result;
}
// host list
addMoreEmail(i){ 
  if((this.form.get('emailsIds') as FormArray).controls[i].value.emailId != ""){
  (this.form.controls['emailsIds'] as FormArray).push(this.newEmail()) }
}
deleteEmail(i){
  (this.form.controls['emailsIds'] as FormArray).removeAt(i);
}
  back() {
    this.stepperChange.emit({ step : 4 });
  }
  
next() {
  this.stepperChange.emit({ step : 6 });
}
  ngOnChanges(filledData: any) {
   if(filledData != undefined){
      this.filledData = filledData.filledData.currentValue;
      console.log(this.filledData,'filledData');
      this.getselectedEligibles();
      this.getselectedPersonalities();
      this.getselectedTravelRequirements();
      this.getselectedHire();
      let emailId:FormArray = this.formBuilder.array([]);
      this.filledData?.JobPostNotificationEmails.map((email)=>{
        emailId.push(this.formBuilder.group({
          emailId : email.emailId,
        }))        
      })   
      
      this.form.patchValue({
        ...this.filledData?.JobPost,
        id:this.filledData?.JobPost?.id, 
        vaccinationCerificate:this.filledData?.JobPost?.vaccinationCerificate.toString(), 
        // emailsIds:emailId, 
      })

      this.form.setControl("emailsIds", emailId) 
    }
  }
  getselectedEligibles(){
    if (this.allEligibles.length > 0 && this.filledData != undefined){
      this.allEligibles.map((elg)=> {
        this.filledData.jobEligibleFor.map((elgid) => {
          if(elg.id == elgid.jobEligibleForId) {
            elg['selected'] = true;
          }
        }) 
      })
    } 
  }
  getselectedPersonalities(){ 
    if (this.allPersonalities.length > 0 && this.filledData != undefined){
      this.allPersonalities.map((pes)=> {
        this.filledData.JobPostPersonalities.map((per) => {
          if(pes.id == per.personalitiesId) {
            pes['selected'] = true;
          }
        }) 
      })
    } 
  }
  getselectedTravelRequirements(){
    if (this.allTravelRequirements.length > 0 && this.filledData != undefined){
      this.allTravelRequirements.map((trav)=> {
        // this.filledData.JobPostAddQuestions.map((postQ) => {
          if(trav.id == this.filledData?.JobPost?.travelRequirementId) {
            trav['selected'] = true;
          }
        // }) 
      })
    } 
  }
  getselectedHire(){
    if (this.allHire.length > 0 && this.filledData != undefined){
      this.allHire.map((hire)=> {
        // this.filledData.JobPostAddQuestions.map((hire) => {
          if(hire.id == this.filledData?.JobPost?.quicklyNeedForHireId) {
            hire['selected'] = true;
          }
        // }) 
      })
    } 
  }
  ngOnInit(): void { 
    (this.form.controls['emailsIds'] as FormArray).push(this.newEmail()) 
    this.getEligibles();
    this.getPersonalities();
    this.getTravelRequirements();
    this.getHire();
    this.getDetail();
  }
  
  getDetail(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getJobs+"/"+this.filledData?.JobPost?.id)
    .subscribe(async (res) => {
      this.filledData = res.data;
      console.log("this.filledData", this.filledData )
    })
  }
  // getEligibles
  getEligibles(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getEligibles)
    .subscribe(async (res) => {
      this.allEligibles = res.data.data;
      this.getselectedEligibles();
     })
  }
  selectedEligibles(i,event){
    if (this.allEligibles[i]["selected"] == true) {
      this.allEligibles[i]["selected"] = false
      event.srcElement.classList.remove("selected") 
    } else {
      this.allEligibles[i]["selected"] = true
      event.srcElement.classList.add("selected") 
    }
  }
  // getPersonalities

  getPersonalities(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._sixTeenPersonality)
    .subscribe(async (res) => {
      this.allPersonalities = res.data.rows;
      this.getselectedPersonalities();
     })
  }
  selectedPersonalities(i,event){
    if (this.allPersonalities[i]["selected"] == true) {
      this.allPersonalities[i]["selected"] = false
      event.srcElement.classList.remove("selected") 
    } else {
      this.allPersonalities[i]["selected"] = true
      event.srcElement.classList.add("selected") 
    }
  }
  // getTravelRequirements
  getTravelRequirements(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getTravelRequirements)
    .subscribe(async (res) => {
      this.allTravelRequirements = res.data.data;
      this.getselectedTravelRequirements();
     })
  }
  selectedTravelRequirements(i,event){
    this.allTravelRequirements.map((sch)=>{
      sch["selected"] = false;
    })
    this.allTravelRequirements[i]["selected"] = true;
  }
  // getTravelRequirements
  getHire(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getHire)
    .subscribe(async (res) => {
      console.log(res,'hire');
      
      this.allHire = res.data.data;
      this.getselectedHire();
     })
  }
  selectedHire(i,event){
    this.allHire.map((sch)=>{
      sch["selected"] = false;
    })
    this.allHire[i]["selected"] = true;
  }

  // on submit
  onSubmit(){
    let hired = ""
    this.allHire.map((hire) => {
      if(hire["selected"] == true) {
        if (hired == "") {
          hired = hire.id
        } else {
          hired = hired + "," + hire.id
        }
      }
    })
    let travel = ""
    this.allTravelRequirements.map((trav) => {
      if(trav["selected"] == true) {
        if (travel == "") {
          travel = trav.id
        } else {
          travel = travel + "," + trav.id
        }
      }
    })
    let Personalities:any=[];
    this.allPersonalities.map((pers)=>{  
      if (pers["selected"] == true){
        Personalities.push({"personalitiesId":pers.id})
    }
    })
    let Eligibles :any=[];
    this.allEligibles.map((elg) => {
      if (elg["selected"] == true){
        Eligibles.push({"jobEligibleForId":elg.id})
      }
    }) 

    let emptyEmailPos : any = []
    for (let i=0; i< this.form.value.emailsIds.length; i++){
      if (this.form.value.emailsIds[i]["emailId"] == "") {
        emptyEmailPos.push(i);
      }
    }
    emptyEmailPos.map((pos) => {
      this.deleteEmail(pos);
    })
    
    this.form.patchValue({
      countryCode:'+1',
      jobEligibleForId:Eligibles,
      personalitiesIds:Personalities,
      travelRequirementId:travel,
      quicklyNeedForHireId:hired,
      steps:5,
    }) 
    if(this.form.valid){
      this.api.putData(apiUrl._getJobs, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.valueChange.emit({ data: res.data.result.payload });
      })
      
    } else{
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
    }
  }
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
}
